import { dom, library } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faTelegram,
  faWhatsapp,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import {
  faCalendar as farCalendar,
  faCheckCircle as farCheckCircle,
  faCircle as farCircle,
  faCircleCheck as farCircleCheck,
  faCircleXmark as farCircleXmark,
  faClipboard as farClipboard,
  faClock as farClock,
  faCopy as farCopy,
  faEnvelope as farEnvelope,
  faFaceFrown,
  faFaceGrin,
  faFaceLaugh,
  faFaceMeh as farFaceMeh,
  faFile as farFile,
  faFileLines as farFileLines,
  faStar as farStar,
  faUser as farUser,
} from '@fortawesome/free-regular-svg-icons';
import {
  faAngleRight,
  faAngleUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowRotateRight,
  faArrowsRotate,
  faArrowsSplitUpAndLeft,
  faArrowTrendUp,
  faArrowUp,
  faArrowUpFromBracket,
  faArrowUpRightFromSquare,
  faBan,
  faBarcode,
  faBars,
  faBath,
  faBed,
  faBell,
  faBold,
  faBookmark,
  faBriefcase,
  faBuilding,
  faBuildingColumns,
  faBuildingWheat,
  faBullseye,
  faCalendar,
  faCalendarAlt,
  faCar,
  faCarRear,
  faCarSide,
  faChalkboardUser,
  faChartGantt,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleDown,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlay,
  faCircleXmark,
  faClipboard,
  faClipboardList,
  faClock,
  faClockRotateLeft,
  faCloudArrowDown,
  faCloudArrowUp,
  faCoins,
  faComment,
  faCopy,
  faCreditCard,
  faDollar,
  faDollarSign,
  faDownload,
  faEarListen,
  faEdit,
  faEllipsis,
  faEllipsisVertical,
  faEnvelope,
  faExclamation,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFaceSmile,
  faFaceTired,
  faFile,
  faFileCirclePlus,
  faFileContract,
  faFileImport,
  faFileInvoiceDollar,
  faFileLines,
  faFilter,
  faFilterCircleXmark,
  faFolderOpen,
  faForwardStep,
  faGear,
  faGrip,
  faHandHoldingDollar,
  faHandshake,
  faHandshakeAngle,
  faHeading,
  faHeadphones,
  faHeart,
  faHeartCrack,
  faHome,
  faHouse,
  faHouseCircleCheck,
  faHouseFlag,
  faIdCard,
  faIndustry,
  faInfo,
  faItalic,
  faLayerGroup,
  faLightbulb,
  faLink,
  faLinkSlash,
  faList,
  faListCheck,
  faListOl,
  faListUl,
  faLocationDot,
  faLock,
  faMagnifyingGlass,
  faMagnifyingGlassChart,
  faMagnifyingGlassDollar,
  faMapLocationDot,
  faMapPin,
  faMoneyBills,
  faMoneyBillWave,
  faMoon,
  faPalette,
  faPen,
  faPencil,
  faPenToSquare,
  faPercent,
  faPersonDigging,
  faPhone,
  faPlay,
  faPlayCircle,
  faPlus,
  faPowerOff,
  faQuestion,
  faQuoteLeft,
  faRankingStar,
  faRobot,
  faRotateRight,
  faRulerCombined,
  faSackDollar,
  faSackXmark,
  faSave,
  faScaleUnbalanced,
  faSearch,
  faShare,
  faStar,
  faStore,
  faSun,
  faTableList,
  faTag,
  faTags,
  faTimes,
  faTimesCircle,
  faTrash,
  faTriangleExclamation,
  faTrophy,
  faTruckPickup,
  faUpload,
  faUser,
  faUserCheck,
  faUsers,
  faUsersGear,
  faWallet,
  faWandMagicSparkles,
  faWarehouse,
  faWarning,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

let hasConfiguredFontAwesome = false;

const fontAwesomeIcons = [
  faAngleRight,
  faAngleUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowRotateRight,
  faArrowTrendUp,
  faArrowUp,
  faArrowUpFromBracket,
  faArrowUpRightFromSquare,
  faArrowsRotate,
  faArrowsSplitUpAndLeft,
  faBan,
  faBarcode,
  faBars,
  faBath,
  faBed,
  faBell,
  faBold,
  faBookmark,
  faBriefcase,
  faBuilding,
  faBuildingColumns,
  faBuildingWheat,
  faBullseye,
  faCalendar,
  faCalendarAlt,
  faCar,
  faCarRear,
  faCarSide,
  faChalkboardUser,
  faChartGantt,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleDown,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlay,
  faCircleXmark,
  faClipboard,
  faClock,
  faClockRotateLeft,
  faCloudArrowDown,
  faCloudArrowUp,
  faCoins,
  faComment,
  faCopy,
  faCreditCard,
  faDollar,
  faDollarSign,
  faDownload,
  faEarListen,
  faEdit,
  faEllipsis,
  faEllipsisVertical,
  faEnvelope,
  faExclamation,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFacebook,
  faFaceFrown,
  faFaceGrin,
  faFaceLaugh,
  faFaceSmile,
  faFaceTired,
  faFile,
  faFileCirclePlus,
  faFileContract,
  faFileImport,
  faFileInvoiceDollar,
  faFileLines,
  faFilter,
  faFilterCircleXmark,
  faFolderOpen,
  faForwardStep,
  farCalendar,
  farCheckCircle,
  farCircle,
  farCircleCheck,
  farCircleXmark,
  farClipboard,
  farClock,
  farCopy,
  farEnvelope,
  farFaceMeh,
  farFile,
  farFileLines,
  farStar,
  farUser,
  faClipboardList,
  faGear,
  faGrip,
  faHandHoldingDollar,
  faHandshake,
  faHandshakeAngle,
  faHeading,
  faHeadphones,
  faHeart,
  faHeartCrack,
  faHome,
  faHouse,
  faHouseCircleCheck,
  faHouseFlag,
  faIdCard,
  faIndustry,
  faInfo,
  faInstagram,
  faItalic,
  faLayerGroup,
  faLightbulb,
  faLinkedin,
  faLink,
  faLinkSlash,
  faList,
  faListCheck,
  faListOl,
  faListUl,
  faLocationDot,
  faLock,
  faMagnifyingGlass,
  faMagnifyingGlassChart,
  faMagnifyingGlassDollar,
  faMapLocationDot,
  faMapPin,
  faMoneyBillWave,
  faMoneyBills,
  faMoon,
  faPalette,
  faPen,
  faPenToSquare,
  faPencil,
  faPercent,
  faPersonDigging,
  faPhone,
  faPlay,
  faPlayCircle,
  faPlus,
  faPowerOff,
  faQuestion,
  faQuoteLeft,
  faRankingStar,
  faRobot,
  faRotateRight,
  faRulerCombined,
  faSackDollar,
  faSackXmark,
  faSave,
  faScaleUnbalanced,
  faSearch,
  faShare,
  faStar,
  faStore,
  faSun,
  faTableList,
  faTag,
  faTags,
  faTelegram,
  faTimes,
  faTimesCircle,
  faTrash,
  faTriangleExclamation,
  faTrophy,
  faTruckPickup,
  faUpload,
  faUser,
  faUserCheck,
  faUsers,
  faUsersGear,
  faWallet,
  faWandMagicSparkles,
  faWarehouse,
  faWarning,
  faWhatsapp,
  faYoutube,
];

export const setupFontAwesome = () => {
  if (hasConfiguredFontAwesome) {
    return;
  }

  library.add(...fontAwesomeIcons);
  dom.watch();
  hasConfiguredFontAwesome = true;
};

export { FontAwesomeIcon };
